import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../store/indexStore";
import { SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";

const LangSelect = () => {
  const { changeLang, lang, changeLangBottomSheet } = indexStore();
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  useEffect(() => {
    const handleLanguageChange = () => {
      i18n.changeLanguage(lang);
      document.documentElement.dir = i18n.dir();
    };

    if (lang) {
      handleLanguageChange();
    } else {
      changeLang(localStorage.getItem("Lang") || "ar");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  const handleLanguageSelect = (isArabic: boolean) => {
    changeLang(isArabic ? "ar" : "en");
    changeLangBottomSheet(false);
  };

  return (
    <SheetContent
    hiddenCloseButton={true}
      side="bottom"
      className="flex rounded-t-2xl flex-col bg-background border-t-2 border-primary/20 shadow-lg z-50 p-0 max-h-[50vh]"
    >
      {/* Header */}
      <SheetHeader className="px-6 pt-6 pb-4 ">
        <SheetTitle>
          <h2 className="text-xl font-bold text-foreground">
            {t("gloabl.changeLang")}
          </h2>
        </SheetTitle>
      </SheetHeader>

      {/* Language Options */}
      <div className="flex flex-col gap-2 p-4">
        <button
          onClick={() => handleLanguageSelect(true)}
          className={`w-full text-center px-4 py-4 rounded-xl font-semibold text-lg transition-all duration-300 ${
            lang === "ar"
              ? "bg-primary text-onPrimary shadow-md"
              : "bg-muted/50 text-foreground hover:bg-muted border-2 border-border/50"
          }`}
        >
          العربية
        </button>
        <button
          onClick={() => handleLanguageSelect(false)}
          className={`w-full text-center px-4 py-4 rounded-xl font-semibold text-lg transition-all duration-300 ${
            lang === "en"
              ? "bg-primary text-onPrimary shadow-md"
              : "bg-muted/50 text-foreground hover:bg-muted border-2 border-border/50"
          }`}
        >
          English
        </button>
      </div>
    </SheetContent>
  );
};

export default LangSelect;
